import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/Layout/Layout';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Registratura from './pages/Registratura/Registratura';
import Gestiune from './pages/Gestiune/Gestiune';
import Furnizori from './pages/Gestiune/Furnizori';
import Tranzactii from './pages/Gestiune/Tranzactii';
import FacturiIntrare from './pages/Gestiune/FacturiIntrare';
import FacturiIesire from './pages/Gestiune/FacturiIesire';
import DevizeMateriale from './pages/Gestiune/DevizeMateriale';
import BonuriTransfer from './pages/Gestiune/BonuriTransfer';
import Plati from './pages/Gestiune/Plati';
import Inventar from './pages/Gestiune/Inventar';
import Concedii from './pages/Concedii/Concedii';
import Pontaje from './pages/Pontaje/Pontaje';
import Angajati from './pages/Angajati/Angajati';
import AdministrareUtilizatori from './pages/AdministrareUtilizatori/AdministrareUtilizatori';
import Parohii from './pages/Parohii/Parohii';
import Gestiuni from './pages/Gestiuni/Gestiuni';
// Import administrative structure pages
import Cancelarie from './pages/Cancelarie/Cancelarie';
import OficiulJuridic from './pages/OficiulJuridic/OficiulJuridic';
import OficiulCanonic from './pages/OficiulCanonic/OficiulCanonic';
import CorpulDeInspectie from './pages/CorpulDeInspectie/CorpulDeInspectie';
import ConsiliulEparhial from './pages/ConsiliulEparhial/ConsiliulEparhial';
import SectorulAdministrativBisericesc from './pages/SectorulAdministrativBisericesc/SectorulAdministrativBisericesc';
import SectorulPastoralLiturgic from './pages/SectorulPastoralLiturgic/SectorulPastoralLiturgic';
import SectorulCateheticEducational from './pages/SectorulCateheticEducational/SectorulCateheticEducational';
import SectorulCulturalTineretEditorial from './pages/SectorulCulturalTineretEditorial/SectorulCulturalTineretEditorial';
import SectorulEconomic from './pages/SectorulEconomic/SectorulEconomic';
import SectorulSocialFilantropic from './pages/SectorulSocialFilantropic/SectorulSocialFilantropic';
import SectorulMassMedia from './pages/SectorulMassMedia/SectorulMassMedia';
import SectorulPatrimoniu from './pages/SectorulPatrimoniu/SectorulPatrimoniu';
import ComisiaDeCultura from './pages/ComisiaDeCultura/ComisiaDeCultura';
import DepartamentulCimitire from './pages/DepartamentulCimitire/DepartamentulCimitire';
import ComisiaDeInventar from './pages/ComisiaDeInventar/ComisiaDeInventar';
import AdministratiaControlFinanciar from './pages/AdministratiaControlFinanciar/AdministratiaControlFinanciar';
import OficiulTehnic from './pages/OficiulTehnic/OficiulTehnic';
import Contracte from './pages/Contracte/Contracte';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Routes>
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} 
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/registratura" element={<Registratura />} />
                  <Route path="/gestiune" element={<Gestiune />} />
                  <Route path="/gestiune/furnizori" element={<Furnizori />} />
                  <Route path="/gestiune/tranzactii" element={<Tranzactii />} />
                  <Route path="/gestiune/facturi-intrare" element={<FacturiIntrare />} />
                  <Route path="/gestiune/facturi-iesire" element={<FacturiIesire />} />
                  <Route path="/gestiune/devize-materiale" element={<DevizeMateriale />} />
                  <Route path="/gestiune/bonuri-transfer" element={<BonuriTransfer />} />
                  <Route path="/gestiune/plati" element={<Plati />} />
                  <Route path="/gestiune/inventar" element={<Inventar />} />
                  <Route path="/concedii" element={<Concedii />} />
                  <Route path="/pontaje" element={<Pontaje />} />
                  <Route path="/angajati" element={<Angajati />} />
                  <Route path="/administrare-utilizatori" element={<AdministrareUtilizatori />} />
                  <Route path="/gestiuni" element={<Gestiuni />} />
                  <Route path="/parohii" element={<Parohii />} />
                  <Route path="/contracte" element={<Contracte />} />
                  {/* Administrative Structure Routes */}
                  <Route path="/cancelarie" element={<Cancelarie />} />
                  <Route path="/oficiul-juridic" element={<OficiulJuridic />} />
                  <Route path="/oficiul-canonic" element={<OficiulCanonic />} />
                  <Route path="/corpul-inspectie" element={<CorpulDeInspectie />} />
                  <Route path="/consiliul-eparhial" element={<ConsiliulEparhial />} />
                  <Route path="/sectorul-administrativ-bisericesc" element={<SectorulAdministrativBisericesc />} />
                  <Route path="/sectorul-pastoral-liturgic" element={<SectorulPastoralLiturgic />} />
                  <Route path="/sectorul-catehetic-educational" element={<SectorulCateheticEducational />} />
                  <Route path="/sectorul-cultural-tineret-editorial" element={<SectorulCulturalTineretEditorial />} />
                  <Route path="/sectorul-economic" element={<SectorulEconomic />} />
                  <Route path="/sectorul-social-filantropic" element={<SectorulSocialFilantropic />} />
                  <Route path="/sectorul-mass-media" element={<SectorulMassMedia />} />
                  <Route path="/sectorul-patrimoniu" element={<SectorulPatrimoniu />} />
                  <Route path="/comisia-de-cultura" element={<ComisiaDeCultura />} />
                  <Route path="/departamentul-cimitire" element={<DepartamentulCimitire />} />
                  <Route path="/comisia-de-inventar" element={<ComisiaDeInventar />} />
                  <Route path="/administratia-control-financiar" element={<AdministratiaControlFinanciar />} />
                  <Route path="/oficiul-tehnic" element={<OficiulTehnic />} />
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Box>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
